import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import MeasuredGrid from './MeasuredGrid';
import { adjustBreakpointHeight, DEFAULT_BREAKPOINTS } from './breakpoints';
export const StandardGrid = (_param)=>{
    var { adjustHeight = 0, breakpoints = DEFAULT_BREAKPOINTS, children } = _param, props = _object_without_properties(_param, [
        "adjustHeight",
        "breakpoints",
        "children"
    ]);
    return /*#__PURE__*/ React.createElement(MeasuredGrid, _object_spread_props(_object_spread({}, props), {
        breakpoints: adjustHeight ? adjustBreakpointHeight(breakpoints, adjustHeight) : breakpoints,
        renderElement: children
    }));
};
export default StandardGrid;

//# sourceMappingURL=StandardGrid.js.map